var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-10',[_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-header"},[_c('h3',{staticStyle:{"font-size":"40px"}},[_vm._v("现场工种")])]),_c('div',{ref:"workType",staticStyle:{"width":"100%","height":"80%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }